/*
具体的业务数据接口
*/
import { request } from '@/utils/request'
const BusinessData = {
  state: {},

  mutations: {},

  actions: {
    // 负荷预测分析
    /*
    @params
    树节点ID
    GUID: NjkwOEEzQUI4NTBBMjVCRA
    */
    GetFuHeYuCeFenXi({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/tongji/v2/GetFuHeYuCeFenXi',
          params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 月用电分析
    GetYueYongDianFenXi({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/tongji/v2/GetYueYongDianFenXi',
          params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 点击分组获取分组设备用电信息
    /*
    @params
    树节点ID
    GUID: NjkwOEEzQUI4NTBBMjVCRA
    */
    GetEquipmentInfoByGroup({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/tongji/v2/GetEquipmentInfoByGroup',
          params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 设备详情
     */
    EquipmentMainInfoDetails({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/EquipmentMainInfoDetails',params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 设备健康度列表
     */
    GetJKDProjectListInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/GetJKDProjectListInfo',params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取设备的告警记录
     */
    GetWarningRecordsByEquipmentID({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/GetWarningRecordsByEquipmentID',params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default BusinessData
